import { localeSegmentList } from './constants';

/**
 * Removes locale segment from URL--needed for certain redirect logic that uses originalURL.
 */
export function removeLocaleSegment<T>(url: T): T | string {
    if (typeof url !== 'string') {
        return url;
    }
    const re = new RegExp(`^\/(${localeSegmentList.filter(Boolean).join('|')})\/`);
    return url.replace(re, '/');
}
